module.exports = __webpack_public_path__ + "img/BicolAllottee2025.7b6d8a66.jpg";